import { Button, Card, Col, Form, Input, Modal, PageHeader, Row, Spin, Switch } from 'antd';
import React, { Component } from 'react';
const { TextArea } = Input;
import { urlapi, token, pathimages, CheckTokenExp } from '../../config';

class AccountsDetail extends Component {
  constructor(props) {
    super(props);

    this.onChangeinput = this.onChangeinput.bind(this);
    this.handleSave = this.handleSave.bind(this)
    this.getSendFlexUrl = this.getSendFlexUrl.bind(this)

    this.state = {
      sendFlex: false,
      channelId: "",
      channelSecret: "",
      accessToken: "",
      refreshToken: "",
      linkUrl: "",
      loading: false
    }
  }

  componentDidMount() {
    this.getSendFlexUrl();
  }

  getSendFlexUrl() {
    if (!CheckTokenExp()) {
      fetch(urlapi + "api/getSendFlexUrl", {
        method: 'get',
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Authorization": "Bearer " + token
        },
      })
        .then((data) => {
          if (data.ok) {
            console.log("data--", data);
            return data.json();  // Return the promise of `data.json()`
          }
        })
        .then((json) => {
          console.log("json--", json);
          if (json.linkUrl !== null) {
            this.setState({
              linkUrl: json.linkUrl,
              sendFlex: true
            });
          }
        })
        .catch(() => {
          Modal.error({
            content: 'Error on the internal server.',
          });
        });
    } else {
      this.props.history.push("/logout");
    }
  }


  onChangeinput(name, value) {
    this.setState({ [name]: value });
  }

  handleSave() {
    if (!CheckTokenExp()) {
      this.setState({ loading: true });

      let req = JSON.stringify({
        sendFlex: this.state.sendFlex,
        linkUrl: this.state.linkUrl
      });

      fetch(urlapi + "api/updateSendFlex", {
        method: 'post',
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "Authorization": "Bearer " + token
        },
        body: req
      })
        .then((data) => {
          if (data.ok) {
            return data.json();  // Return the JSON response
          } 
        })
        .then((json) => {
          this.setState({
            loading: false
          });

          if (json.message = "success") {
            Modal.success({
              content: "Successful! Save link URL is success",
            });
          } else {
            Modal.error({
              content: json.description,
            });
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          Modal.error({
            content: 'Error on the internal server',
          });
        });
    } else {
      this.props.history.push("/logout");
    }
  }


  render() {
    const { sendFlex, linkUrl } = this.state

    return (
      <div>
        <PageHeader title="Account Management">
        </PageHeader>
        <div className="content">
          <Spin spinning={this.state.loading}>
            <Card>
              <Row gutter={[20, 20]}>
                {/* <Col span={24}>
                <Row>
                  <Col xs={24} sm={8} md={8}>
                    <label className="control-label">Channel ID :</label>
                  </Col>
                  <Col xs={24} sm={16} md={12}>
                    <Input name='channelId' placeholder="Channel ID" />
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col xs={24} sm={8} md={8}>
                    <label className="control-label">Channel Secret :</label>
                  </Col>
                  <Col xs={24} sm={16} md={12}>
                    <Input name='channelSecret' placeholder="Channel Secret" />
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col xs={24} sm={8} md={8}>
                    <label className="control-label">Access Token :</label>
                  </Col>
                  <Col xs={24} sm={16} md={12}>
                    <TextArea rows={4} style={{ resize: 'none' }} name='accessToken' placeholder="Access Token" />
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col xs={24} sm={8} md={8}>
                    <label className="control-label">Refresh Token :</label>
                  </Col>
                  <Col xs={24} sm={16} md={12}>
                    <TextArea rows={4} style={{ resize: 'none' }} name='refreshToken' placeholder="Refresh Token" />
                  </Col>
                </Row>
              </Col> */}
                <Col span={24}>
                  <Row>
                    <Col xs={24} sm={8} md={8}>
                      <label className="control-label">Send Flex :</label>
                    </Col>
                    <Col xs={24} sm={16} md={12}>
                      <Switch
                        name="sendFlex"
                        style={{ width: "50px" }}
                        checked={sendFlex}
                        onChange={(value) => {
                          if (value) {
                            this.setState({ sendFlex: value })
                          } else {
                            this.setState({ sendFlex: value, linkUrl: "" })
                          }
                        }}
                      />
                    </Col>
                  </Row>
                </Col>

                {sendFlex && (
                  <Col span={24}>
                    <Row>
                      <Col xs={24} sm={8} md={8}>
                        <label className="control-label">Link to receive Flex Json :</label>
                      </Col>
                      <Col xs={24} sm={16} md={12}>
                        <Input name='linkUrl' placeholder="Link URL" value={linkUrl} onChange={(e) => this.onChangeinput('linkUrl', e.target.value)} />
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>

              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "20px" }}>
                <Button>Discard</Button>
                <Button type="primary" style={{ marginLeft: "10px" }} onClick={this.handleSave} disabled={this.state.sendFlex && !this.state.linkUrl}>Save</Button>
              </div>
            </Card>
          </Spin>
        </div>
      </div>
    )
  }
}

export default AccountsDetail


// WEBPACK FOOTER //
// ./src/views/AccountManagement/AccountDetail.js